import { Head } from "@inertiajs/react";

interface MetaTagsProps {
    title: string;
    description: string;
    keywords?: string;
    image?: string;
    url?: string;
    type?: string;
    canonical?: string;
}

export default function MetaTags({
    title,
    description,
    keywords,
    image = "/crypto-tax-image.png",
    url = "https://cryptotax.com.br",
    type = "website",
    canonical,
}: MetaTagsProps) {
    const fullTitle = `${title} | CryptoTax`;
    const fullImage = image.startsWith("http")
        ? image
        : `https://cryptotax.com.br${image}`;
    const canonicalUrl = canonical || url;

    return (
        <Head>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            {keywords && <meta name="keywords" content={keywords} />}
            <link rel="canonical" href={canonicalUrl} />

            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={fullImage} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:locale" content="pt_BR" />
            <meta property="og:site_name" content="CryptoTax" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={url} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={fullImage} />

            <meta name="robots" content="index, follow" />
            <meta name="googlebot" content="index, follow" />
        </Head>
    );
}
